







































import Vue from "vue";
import { Component, Emit, Prop, VModel, Watch } from 'vue-property-decorator'

import SelectOption from './Pi/fields/SelectInput/components/SelectOption.vue'
import { SelectOptionData } from './Pi/types'

@Component({
  components: {
    SelectOption
  }
})
export default class PiDropdownInput extends Vue {
  @VModel({ type: String, default: '', required: false }) inputValue!: string

  @Prop({ type: Boolean, default: false, required: false }) disabled!: boolean

  @Prop({ type: String, default: '', required: false }) placeholder!: string

  @Prop() dropdownOptions!: Array<SelectOptionData | string>

  @Prop({ type: String, default: '', required: false }) fieldTitle!: string

  @Prop({ type: Boolean, required: false, default: true }) hasAddButton!: boolean

  @Prop({ type: Boolean, required: false, default: true }) clearValue!: boolean

  @Prop({ type: Boolean, required: false, default: true }) isValid!: boolean

  @Prop({ type: Boolean, required: false, default: true }) filterOptions!: boolean

  @Prop() inputLike!: boolean

  @Emit()
  onAdd(value: string): string {
    return value.trim()
  }

  change(e: string) {
    if (this.inputLike) {
      this.onAdd(e.trim())
    }
  }

  stateValue = ''

  @Watch('inputValue', { immediate: true })
  onInputValueChange(v: string | undefined) {
    if (typeof v === 'string') {
      this.stateValue = v
    }
  }

  isDropdownOpen = false

  get title() {
    return this.fieldTitle ? `${ this.fieldTitle }_` : ''
  }

  isSelectOption(option: SelectOptionData | string): option is SelectOptionData {
    return typeof option === 'object' && 'value' in option && 'label' in option;
  }

  get queriedOptions() {
    if (this.filterOptions) {
      if (this.stateValue.trim().length) {
        return this.dropdownOptions.filter(o => {
          if (this.isSelectOption(o)) {
            return o.label.toLowerCase().includes(this.stateValue.toLowerCase())
          } else {
            return o.toLowerCase().includes(this.stateValue.toLowerCase())
          }
        })
      }

      return this.dropdownOptions
    }

    return this.dropdownOptions
  }

  handleAdd(value: string) {
    this.onAdd(value)

    this.isDropdownOpen = false

    if (this.clearValue) {
      this.stateValue = ''
    }
  }
}
